import React from 'react'
import PropTypes from 'prop-types'
import { Count } from './ProductCountStyledComponents'

const ProductCount = React.memo(({ show, ...rest }) =>
  show ? <Count {...rest} /> : <p />
)

ProductCount.displayName = 'ProductCount'

ProductCount.propTypes = {
  show: PropTypes.bool
}

export default ProductCount
